module.exports = __webpack_public_path__ + "static/naaznin-50f39fa5b135189e5eebeb985b3f76a9.jpg";